export type StepsPath =
  | 'stepper:main:createTeam'
  | 'stepper:main:createPlayer'
  | 'stepper:main:createTournament'
  | 'stepper:main:applicationTeam'
  | 'stepper:main:startTournament'
  | 'stepper:main:manageTournament';

export type StepperClosePath = 'stepper:main:close';

export class StepperMainTool {
  public static getByPath(path: StepsPath | StepperClosePath) {
    if (!path) {
      return false;
    }

    return localStorage.getItem(path) === 'true';
  }

  public static setByPath(path: StepsPath | StepperClosePath, value: boolean) {
    if (!path) {
      return false;
    }

    localStorage.setItem(path, value.toString());
    return value;
  }

  public static toggleByPath(path: StepsPath | StepperClosePath) {
    if (!path) {
      return;
    }

    if (StepperMainTool.getByPath(path)) {
      StepperMainTool.setByPath(path, true);
    } else {
      StepperMainTool.setByPath(path, false);
    }
  }
}
